import React, { useState } from "react";
import { Hero } from "./components/Hero";
import { Testimonials } from "./components/Testimonials";
import { PainPoints } from "./components/PainPoints";
import { Audience } from "./components/Audience";
import { Overview } from "./components/Overview";
import { Volumes } from "./components/Volumes";
import { Bonuses } from "./components/Bonuses";
import { Comparison } from "./components/Comparison";
import { Offer } from "./components/Offer";
import { PremiumUpsell } from "./components/PremiumUpsell";
import { Guarantee } from "./components/Guarantee";
import { FAQ } from "./components/FAQ";
import { FinalOffer } from "./components/FinalOffer";
import { Footer } from "./components/Footer";
import { StickyCTA } from "./components/StickyCTA";
import { useCountdown } from "./hooks/useCountdown";
import { useMetaPixel } from "./hooks/useMetaPixel";
import type { PlanId } from "./types/pricing";
const START_SECONDS = 23 * 3600 + 49 * 60 + 1;
export function App() {
  useMetaPixel();
  const time = useCountdown(START_SECONDS);
  const [plan, setPlan] = useState<PlanId>("premium");
  return <div className="min-h-screen w-full max-w-full overflow-x-clip bg-paper" data-id="element-0" data-mp="3mkhofzsx1e8o">
      <Hero data-id="element-1" data-mp="3rbrcwx2qabiz" />
      <main data-id="element-2" data-mp="3rdas0kcnegj6">
        <Testimonials data-id="element-3" data-mp="3rdkkqfp2v1sk" />
        <PainPoints data-id="element-4" data-mp="3recd7hndojem" />
        <Audience data-id="element-5" data-mp="5yhgo69t1c8" />
        <Overview data-id="element-6" data-mp="6htxpd5ixiv" />
        <Volumes data-id="element-7" data-mp="4wylxj0jajy" />
        <Bonuses data-id="element-8" data-mp="5gbgztt38r4" />
        <Comparison data-id="element-9" data-mp="82ohezguggq" />
        <Offer time={time} plan={plan} onPlanChange={setPlan} data-id="element-10" data-mp="2zld0l5ad579f" />
        <PremiumUpsell data-id="element-11" data-mp="2zmwh8wzxlkbq" />
        <Guarantee data-id="element-12" data-mp="33mouvo46mgny" />
        <FAQ data-id="element-13" data-mp="33m5ck6amdq9e" />
        <FinalOffer time={time} plan={plan} onPlanChange={setPlan} data-id="element-14" data-mp="33nq5xsl7735o" />
      </main>
      <Footer data-id="element-15" data-mp="38l8j5v6904jh" />
      <StickyCTA time={time} data-id="element-16" data-mp="38kqcs5pvg9xu" />
    </div>;
}